var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-5 bg-white shadow-md"},[_c('div',{staticClass:"mx-auto max-w-gw-wrapper "},[_c('div',{staticClass:"global-nav z-10"},[_c('AppHeaderMenuDesktop')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }